import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';

// Use throughout your app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Also export as default for consistency with useAppSelector
export default useAppDispatch;